import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { DriverById } from '../../drivers/models/driver-by-id.model';

export interface DriverGateway {
  getDriverById(driverId: number, accountId?: number | string): Observable<DriverById>;
  getLimitById(driverId: number, accountId?: number | string): Observable<any>;
  getWorkingHoursByDriver(driverId: number, accountId?: number | string): Observable<any>;
  blockUnblock(driverId: number, accountId?: number | string): Observable<any>;
}

export const DRIVER_GATEWAY = new InjectionToken<DriverGateway>('DRIVER_GATEWAY');
